import { render } from "./TheImpressum.vue?vue&type=template&id=827e18fc&scoped=true"
const script = {}

import "./TheImpressum.vue?vue&type=style&index=0&id=827e18fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827e18fc"]])

export default __exports__